import ToolbarPopover from "@/appComponents/Navigation/ContextualToolbar/ToolbarPopover/ToolbarPopover";

export const kLayoutToolbarOffset = 10;

export const LayoutToolbar = props => (
  <ToolbarPopover
    overlayProps={{
      padding: 0,
      ...props.overlayProps
    }}
    otherPopoverProps={{
      offsetOptions: kLayoutToolbarOffset,
      reference: null,
      ...props.popoverProps,
      floatingCtrlRef: props.floatingCtrlRef,
      openCtrlRef: props.openCtrlRef,
      shiftOptions: { crossAxis: true }
    }}
  >
    {props?.children}
  </ToolbarPopover>
);
